import { GetStaticProps } from "next";
import ReleasePage from "../../components/Releases/ReleasePage";
import {
  getStaticPropsForPostsPage,
  PostsPageProps,
  PostType,
} from "../../utils/posts";
import { FlashPCBPage } from "../../models/page";

const BlogPostsPage: FlashPCBPage<PostsPageProps> = ({ posts }) =>
  posts.length > 0 ? (
    <ReleasePage title="Blog" posts={posts} />
  ) : (
    <div>There are no blogposts to display yet.</div>
  );

export const getStaticProps: GetStaticProps = getStaticPropsForPostsPage(
  PostType.BLOG,
);

export default BlogPostsPage;
